import script from "./AccountSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountSettings.vue?vue&type=script&setup=true&lang=js"

import "./AccountSettings.vue?vue&type=style&index=0&id=02f802a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f802a0"]])

export default __exports__